module.exports = __webpack_public_path__ + "img/img-87e13d.jpg";